import ToastService from "./Toast.Service";
import Router, {useRouter} from "next/router";

class RouterService {
    removeQueryParam(router, paramNameToRemove) {

        // Get the current query parameters
        const queryParams = {...router.query};

        // Check if the parameter to remove exists in the current query
        if (queryParams[paramNameToRemove]) {
            // Remove the parameter
            delete queryParams[paramNameToRemove];

            // Update the URL without causing a page reload
            router.replace({
                pathname: router.pathname, // Keep the same pathname
                query: queryParams, // Updated query parameters
            });
        }
    }

    addQueryParam(router, paramNameToAdd, paramValueToAdd) {
        // Get the current query parameters
        const queryParams = {...router.query};

        // Add the parameter and its value
        queryParams[paramNameToAdd] = paramValueToAdd;

        // Update the URL without causing a page reload
        router.replace({
            pathname: router.pathname, // Keep the same pathname
            query: queryParams, // Updated query parameters
        })
    }
}


export default new RouterService();
